import React from 'react';
import { PanelHelp as PanelHelpCE } from '@wix/wix-ui-icons-common/classic-editor/system';
import { PanelHelp as PanelHelpRE } from '@wix/wix-ui-icons-common/responsive-editor/system';
import { WixBaseUiEnvironmentContext } from '../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
var PanelHelpIcon = function PanelHelpIcon() {
  var context = React.useContext(WixBaseUiEnvironmentContext);
  return (context === null || context === void 0 ? void 0 : context.theme) === 'responsive' ? /*#__PURE__*/React.createElement(PanelHelpRE, null) : /*#__PURE__*/React.createElement(PanelHelpCE, null);
};
export default PanelHelpIcon;